import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/modules/auth/store/auth.store";
import { FullScreenLoader } from "@/components/ui/FullScreenLoader";

/**
 * Protected route wrapper.
 * - Hydration davom etayotganda — full-screen loader
 * - Auth yo'q + hydration tugagan — /login ga redirect
 * - Auth bor — children render
 */
export function AuthGuard({ children }: { children: ReactNode }) {
  const accessToken = useAuthStore((s) => s.accessToken);
  const isHydrating = useAuthStore((s) => s.isHydrating);
  const location = useLocation();

  if (isHydrating) {
    return <FullScreenLoader label="Yuklanmoqda..." />;
  }

  if (!accessToken) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
